import { render, staticRenderFns } from "./mattersCenter.vue?vue&type=template&id=3d65dd86&scoped=true&"
import script from "./mattersCenter.vue?vue&type=script&lang=js&"
export * from "./mattersCenter.vue?vue&type=script&lang=js&"
import style0 from "./mattersCenter.vue?vue&type=style&index=0&id=3d65dd86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d65dd86",
  null
  
)

export default component.exports